import React from 'react';
import { CardContainer } from './style';

const Card = (props) => {
  return <CardContainer {...props} />;
};

export default Card;
